import deCommon from './de/common.json';
import enCommon from './en/common.json';
import esCommon from './es/common.json';
import frCommon from './fr/common.json';
import jaCommon from './ja/common.json';
import koCommon from './ko/common.json';
import ruCommon from './ru/common.json';
import zhHansCommon from './zh-hans/common.json';

export const getResources = () => ({
  en: { common: enCommon },
  de: { common: deCommon },
  es: { common: esCommon },
  fr: { common: frCommon },
  ja: { common: jaCommon },
  ko: { common: koCommon },
  ru: { common: ruCommon },
  zh: { common: zhHansCommon },
});
